import React from 'react';
export function PackImage() {
  const mainCover = 'https://cdn.magicpatterns.com/uploads/9igeQHSpmhprGitpqpDCso/01_cover.png';
  const bono1 = 'https://cdn.magicpatterns.com/uploads/s26LrkmiL6P94bRi93Kwqw/bono_1.png';
  const bono2 = 'https://cdn.magicpatterns.com/uploads/pAdj646auHxdwGTHgKvSwt/bono_2.png';
  const bono3 = 'https://cdn.magicpatterns.com/uploads/wj5ZvyKzb1DA57psBVDExB/bono_3.png';
  const bono4 = 'https://cdn.magicpatterns.com/uploads/8nGYXgcSp9VcE3pa9Rwq8q/bono_4.png';
  return <div className="relative w-full max-w-2xl mx-auto h-[400px] md:h-[500px] flex items-center justify-center cursor-pointer" onClick={() => document.getElementById('compra')?.scrollIntoView({
    behavior: 'smooth'
  })} data-id="element-130">
      {/* Back layer */}
      <img src={bono4} alt="Bono 4" className="absolute w-[40%] md:w-[45%] transition-transform duration-500 hover:-translate-y-4" style={{
      transform: 'translateX(-40%) translateY(-10%) rotate(-15deg) scale(0.8)',
      zIndex: 1
    }} data-id="element-131" />
      <img src={bono3} alt="Bono 3" className="absolute w-[40%] md:w-[45%] transition-transform duration-500 hover:-translate-y-4" style={{
      transform: 'translateX(40%) translateY(-10%) rotate(15deg) scale(0.8)',
      zIndex: 1
    }} data-id="element-132" />

      {/* Middle layer */}
      <img src={bono2} alt="Bono 2" className="absolute w-[45%] md:w-[50%] transition-transform duration-500 hover:-translate-y-4" style={{
      transform: 'translateX(-25%) translateY(5%) rotate(-8deg) scale(0.9)',
      zIndex: 2
    }} data-id="element-133" />
      <img src={bono1} alt="Bono 1" className="absolute w-[45%] md:w-[50%] transition-transform duration-500 hover:-translate-y-4" style={{
      transform: 'translateX(25%) translateY(5%) rotate(8deg) scale(0.9)',
      zIndex: 2
    }} data-id="element-134" />

      {/* Front main cover */}
      <img src={mainCover} alt="Air Fryer Fácil" className="absolute w-[55%] md:w-[60%] transition-transform duration-500 hover:scale-105" style={{
      zIndex: 10
    }} data-id="element-135" />
    </div>;
}